export const PopoverPositions = ['below', 'above', 'right', 'left'] as const
export type PopoverPosition = (typeof PopoverPositions)[number]

export const PopoverAlignments = ['start', 'center', 'end'] as const
export type PopoverAlignment = (typeof PopoverAlignments)[number]

export const PopoverRoles = [
  // Default popover role.
  'dialog',
  // For lists of selectable items.
  'listbox',
  // For dropdown menus with action items.
  'menu',
] as const
export type PopoverRole = (typeof PopoverRoles)[number]

export const PopoverArrowNavigations = ['both', 'vertical', 'horizontal', 'none'] as const
export type PopoverArrowNavigation = (typeof PopoverArrowNavigations)[number]

export const POPOVER_VIEWPORT_MARGIN = 16 // 1rem
